export default __webpack_public_path__ + "static/media/leaderboard-down-arrow.89a23414.svg";